import React, { Fragment, useState, useContext, useMemo, useEffect } from "react";
import "./styles.css";
import { ReactComponent as Cancel } from "common/assets/svg/cancel.svg";
import { useTransition, animated } from "react-spring";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { RootState } from "common/rootReducer";
import { Offer } from "common/features/offers/offferModels";
import { AuthContext } from "common/services/auth-service";
import OfferCard from "../../../pages/offer/offerCard";
import { ReactComponent as Back } from "common/assets/svg/leftArrow.svg";
import { storeLocationAfterAuth } from "common/features/auth/AuthActions";
import OfferPopUp from "components/prompts/offerPrompt";
import LoginRequestPrompt from "components/prompts/loginRequestPrompt";

import {
  clearSelectedOffer,
  requestOfferVality,
} from "common/features/offers/offerActions";
import { MAGIL_LOCATION } from "common/constants";

interface ConfirmationPromptProps {
  isOpen: boolean;
  onClose: any;
  isCopied: boolean;
}

function LocationPickerPrompt(props: ConfirmationPromptProps) {
  const { isOpen, onClose, isCopied } = props;
  const history = useHistory();

  const location = useLocation<any>();
  const locationState = location.state;
  // console.log("locationState::::", locationState);
  const [code, setCode] = useState<string>("");
  const [isInValidOfferCode, setIsInvalidOfferCode] = useState<boolean>(false);
  const [selectedOfferId, setSelectedOfferId] = useState<string>("");
  const [offerPopup, setofferPopup] = useState(false);
  const [loginRequestPopup, setloginRequestPopup] = useState(false);

  const dispatch = useDispatch();
  const AppAuth = useContext(AuthContext);
  const cartUrl = useSelector((state: RootState) => state.cart.cartURL);

  const restaurantDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );
  const isContactlessDineInOrder = useMemo(() => {
    return (
      window.location.pathname.includes("table") &&
      (restaurantDetails.dining == 2 || restaurantDetails.dining == 3)
    );
  }, [restaurantDetails]);
  const offersList = useSelector((state: RootState) => state.offer.offers);
  const cartRestaurantDetails = useSelector(
    (state: RootState) => state.cart.cartRestaurantDetails
  );

  const applyOffer = () => {
    const selectedOffer = offersList.find((o: Offer) => o.offerCode == code);
    if (selectedOffer) {
      setIsInvalidOfferCode(false);
      dispatch(clearSelectedOffer());
      if (selectedOffer.locationId === MAGIL_LOCATION) {
        AppAuth?.userState == "signedIn"
          ? validateOffer(selectedOffer.offerCode, selectedOffer.id)
          : doAuth();
      } else {
        validateOffer(selectedOffer.offerCode, selectedOffer.id);
      }
    } else {
      setIsInvalidOfferCode(true);
    }
  };

  const doAuth = () => {
    dispatch(storeLocationAfterAuth(location.pathname));
    history.push("/signIn");
  };
  const validateOffer = (offerCode: string, offerId: string) => {
    const userId = localStorage.getItem("USER_ID");
    const validityData = {
      customerId: userId ? userId?.toString() : "",
      offerId: offerId,
      couponCode: offerCode,
      orderId: "",
      locationId: cartRestaurantDetails?.id,
    };

    validityData &&
      cartRestaurantDetails &&
      dispatch(requestOfferVality(validityData));
  };

  const transitions = useTransition(isOpen, null, {
    from: { transform: "translate3d(0,-15px,0)", opacity: 0.4 },
    enter: { transform: "translate3d(0,0px,0)", opacity: 1 },
    leave: { transform: "translate3d(0,-15px,0)", opacity: 0 },
    unique: true,
  });

  const setIsOpen = (set: boolean) => {
    if (set) {
      setofferPopup(false);
    }
  };

  const setIsOpenLogin = (set: boolean) => {
    if (set) {
      setloginRequestPopup(false);
    }
  };

  useEffect(() => {
      const handleBackButton = () => {
        onClose(true);
      };
      window.addEventListener('popstate', handleBackButton);
      return () => {
        window.removeEventListener('popstate', handleBackButton);
      };
  }, [history]);

  return (
    <Fragment>
      <Fragment>
        {isOpen ? <div id="modal-background" style={{ zIndex: '20' }}></div> : null}
        {transitions.map(({ item, key, props }) =>
          item ? (
            <animated.div className="desktop-offer-CPWrapper">
              <animated.div
                className="desktop-offer-CPContainer"
                key={key}
                style={props}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    position: 'sticky',
                    top: '0',
                    backgroundColor: '#fff',
                    padding: '12px 14px',
                    zIndex: '1'
                  }}
                >
                  <Back
                    style={{ marginTop: '4px' }}
                    onClick={() => {
                      onClose(true)
                    }}
                  />
                  <span className="apply-coupon-heading-text">
                    {isCopied ? "Offers" : "Apply Coupons" }
                  </span>
                  <Cancel onClick={() => onClose(true)} />
                </div>
                <div className="desktop-coupon-container">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {!isCopied &&
                    <><div id="desktop-code-text-box-container">
                    <div className="desktop-code-text-box">
                      <input
                        className="pwd"
                        type={"text"}
                        name="offercode"
                        placeholder="Enter or Paste coupon code"
                        autoComplete="off"
                        value={code}
                        onChange={(e: any) => {
                          setCode(e.target.value);
                        }}
                      />
                      <span
                        onClick={() => {
                          applyOffer();
                        }}
                        className="code-text-box-prepend"
                        style={{ color: code.length > 0 ? "#67833e" : "grey" }}
                      >
                        {"Apply"}
                      </span>
                    </div>
                    {isInValidOfferCode && code!= '' && (
                      <span className="invalid-code">Invalid coupon code</span>
                    )}
                  </div>
                  <span className="available-coupons-text">
                    Available Coupons
                  </span></>}
                </div>
                <div className="offer-container">
                  {offersList.length > 0 ? (
                    offersList.map((data, i) => {
                      return (
                        <OfferCard
                          data={data}
                          isShowApplyOffer={true}
                          onClose={onClose}
                          selectedOfferId={selectedOfferId}
                          setSelectedOfferId={(e: any) => {
                            setSelectedOfferId(e);
                          }}
                          setofferPopup={setofferPopup}
                          setloginRequestPopup={setloginRequestPopup}
                          isCopied={isCopied}
                        />
                      );
                    })
                  ) : (
                    <span className="no-offer-text">No Offers Available</span>
                  )}
                </div>
                </div>
              </animated.div>
            </animated.div>
          ) : null
        )}
      </Fragment>
      <OfferPopUp isOpen={offerPopup} visible={setIsOpen} />
      <LoginRequestPrompt
        isOpen={loginRequestPopup}
        visible={setIsOpenLogin}
        title={" Login to avail offer"}
        subtext={" You need to login to apply this promocode."}
        cartUrl={isContactlessDineInOrder ? location.pathname : cartUrl}
      />
    </Fragment>
  );
}

export default LocationPickerPrompt;
